import React, { useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import Typography from "components/typography";
import SearchInput from "components/inputs/search-input";
import Modal from "components/modal";
import Filter from "../filter";
import { IFilter } from "../..";

interface IProps {
  onChangeView: (viewType: string) => void;
  onChangeSearch: (value: string) => void;
  filter: IFilter;
  setFilter: (value: IFilter) => void;
}
const PageHeader = ({
  onChangeView,
  onChangeSearch,
  setFilter,
  filter
}: IProps) => {
  const [viewType, setViewType] = useState("list"); //block
  const [searchInput, setSeachInput] = useState("");
  const [isFilterOpen, setFilterOpen] = useState(false);

  const ChangeViewType = (viewType: string) => {
    onChangeView(viewType);
    setViewType(viewType);
  };

  return (
    <Container>
      <Header>
        <Typography color={Colors.white100} size="4xl" weight="bold" mr="0.4">
          Rated
        </Typography>
        <Typography color={Colors.yellow500} size="4xl" weight="bold">
          Tube
        </Typography>
      </Header>
      <FlexBox>
        <SearchContainer>
          <SearchInput
            placeholder="Search for a Music Video "
            value={searchInput}
            onChange={(e) => {
              setSeachInput(e.target.value);
              onChangeSearch(e.target.value);
            }}
          />
        </SearchContainer>
        <FilterContainer onClick={() => setFilterOpen(true)}>
          <FilterIcon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M7.91602 11.6665C9.29677 11.6665 10.416 12.7858 10.416 14.1665C10.416 15.5472 9.29677 16.6665 7.91602 16.6665C6.53531 16.6665 5.41602 15.5472 5.41602 14.1665C5.41602 12.7858 6.53531 11.6665 7.91602 11.6665Z"
                stroke="white"
                stroke-width="1.25"
              />
              <path
                d="M12.084 3.3335C10.7032 3.3335 9.58398 4.45278 9.58398 5.8335C9.58398 7.2142 10.7032 8.3335 12.084 8.3335C13.4647 8.3335 14.584 7.2142 14.584 5.8335C14.584 4.45278 13.4647 3.3335 12.084 3.3335Z"
                stroke="white"
                stroke-width="1.25"
              />
              <path
                d="M12.5 14.1318H18.3333"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
              />
              <path
                d="M7.49935 5.79883H1.66602"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
              />
              <path
                d="M1.66602 14.1323H3.33268"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
              />
              <path
                d="M18.3327 5.79883H16.666"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
              />
            </svg>
          </FilterIcon>
          <Typography color={Colors.white300} weight="medium">
            Filter
          </Typography>
        </FilterContainer>
        <ViewTypeContainer>
          <ViewTypeItem
            active={viewType === "block" ? "true" : "false"}
            onClick={() => ChangeViewType("block")}
          >
            <ViewTypeIcon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M3.33398 5.00016C3.33398 4.55814 3.50958 4.13421 3.82214 3.82165C4.1347 3.50909 4.55862 3.3335 5.00065 3.3335H6.66732C7.10935 3.3335 7.53327 3.50909 7.84583 3.82165C8.15839 4.13421 8.33398 4.55814 8.33398 5.00016V6.66683C8.33398 7.10886 8.15839 7.53278 7.84583 7.84534C7.53327 8.1579 7.10935 8.3335 6.66732 8.3335H5.00065C4.55862 8.3335 4.1347 8.1579 3.82214 7.84534C3.50958 7.53278 3.33398 7.10886 3.33398 6.66683V5.00016ZM11.6673 5.00016C11.6673 4.55814 11.8429 4.13421 12.1555 3.82165C12.468 3.50909 12.892 3.3335 13.334 3.3335H15.0007C15.4427 3.3335 15.8666 3.50909 16.1792 3.82165C16.4917 4.13421 16.6673 4.55814 16.6673 5.00016V6.66683C16.6673 7.10886 16.4917 7.53278 16.1792 7.84534C15.8666 8.1579 15.4427 8.3335 15.0007 8.3335H13.334C12.892 8.3335 12.468 8.1579 12.1555 7.84534C11.8429 7.53278 11.6673 7.10886 11.6673 6.66683V5.00016ZM3.33398 13.3335C3.33398 12.8915 3.50958 12.4675 3.82214 12.155C4.1347 11.8424 4.55862 11.6668 5.00065 11.6668H6.66732C7.10935 11.6668 7.53327 11.8424 7.84583 12.155C8.15839 12.4675 8.33398 12.8915 8.33398 13.3335V15.0002C8.33398 15.4422 8.15839 15.8661 7.84583 16.1787C7.53327 16.4912 7.10935 16.6668 6.66732 16.6668H5.00065C4.55862 16.6668 4.1347 16.4912 3.82214 16.1787C3.50958 15.8661 3.33398 15.4422 3.33398 15.0002V13.3335ZM11.6673 13.3335C11.6673 12.8915 11.8429 12.4675 12.1555 12.155C12.468 11.8424 12.892 11.6668 13.334 11.6668H15.0007C15.4427 11.6668 15.8666 11.8424 16.1792 12.155C16.4917 12.4675 16.6673 12.8915 16.6673 13.3335V15.0002C16.6673 15.4422 16.4917 15.8661 16.1792 16.1787C15.8666 16.4912 15.4427 16.6668 15.0007 16.6668H13.334C12.892 16.6668 12.468 16.4912 12.1555 16.1787C11.8429 15.8661 11.6673 15.4422 11.6673 15.0002V13.3335Z"
                  stroke="currentColor"
                  stroke-width="1.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </ViewTypeIcon>
          </ViewTypeItem>
          <ViewTypeItem
            active={viewType === "list" ? "true" : "false"}
            onClick={() => ChangeViewType("list")}
          >
            <ViewTypeIcon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M3.33333 6.66667C3.79357 6.66667 4.16667 6.29357 4.16667 5.83333C4.16667 5.3731 3.79357 5 3.33333 5C2.8731 5 2.5 5.3731 2.5 5.83333C2.5 6.29357 2.8731 6.66667 3.33333 6.66667Z"
                  fill="currentColor"
                />
                <path
                  d="M3.33333 10.8332C3.79357 10.8332 4.16667 10.4601 4.16667 9.99984C4.16667 9.5396 3.79357 9.1665 3.33333 9.1665C2.8731 9.1665 2.5 9.5396 2.5 9.99984C2.5 10.4601 2.8731 10.8332 3.33333 10.8332Z"
                  fill="currentColor"
                />
                <path
                  d="M3.33333 15.0002C3.79357 15.0002 4.16667 14.6271 4.16667 14.1668C4.16667 13.7066 3.79357 13.3335 3.33333 13.3335C2.8731 13.3335 2.5 13.7066 2.5 14.1668C2.5 14.6271 2.8731 15.0002 3.33333 15.0002Z"
                  fill="currentColor"
                />
                <path
                  d="M16.7173 9.1665H6.61732C6.18469 9.1665 5.83398 9.51721 5.83398 9.94984V10.0498C5.83398 10.4825 6.18469 10.8332 6.61732 10.8332H16.7173C17.1499 10.8332 17.5007 10.4825 17.5007 10.0498V9.94984C17.5007 9.51721 17.1499 9.1665 16.7173 9.1665Z"
                  fill="currentColor"
                />
                <path
                  d="M16.7173 13.3335H6.61732C6.18469 13.3335 5.83398 13.6842 5.83398 14.1168V14.2168C5.83398 14.6495 6.18469 15.0002 6.61732 15.0002H16.7173C17.1499 15.0002 17.5007 14.6495 17.5007 14.2168V14.1168C17.5007 13.6842 17.1499 13.3335 16.7173 13.3335Z"
                  fill="currentColor"
                />
                <path
                  d="M16.7173 5H6.61732C6.18469 5 5.83398 5.35071 5.83398 5.78333V5.88333C5.83398 6.31596 6.18469 6.66667 6.61732 6.66667H16.7173C17.1499 6.66667 17.5007 6.31596 17.5007 5.88333V5.78333C17.5007 5.35071 17.1499 5 16.7173 5Z"
                  fill="currentColor"
                />
              </svg>
            </ViewTypeIcon>
          </ViewTypeItem>
        </ViewTypeContainer>
      </FlexBox>

      <Modal isActive={isFilterOpen} closeModal={() => setFilterOpen(false)}>
        <Filter
          close={() => setFilterOpen(false)}
          setFilter={(value) => {
            setFilter(value);
          }}
          filter={filter}
        />
      </Modal>
    </Container>
  );
};

export default PageHeader;

const Container = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1.6rem;
  border-bottom: 0.5px solid ${Colors.grey600};
  margin-bottom: 0.8rem;
  @media only screen and (max-width: 769px) {
    grid-template-columns: 100%;
    grid-row-gap: 1.6rem;
  }
`;

const Header = styled.div`
  display: inline-flex;
`;

const FlexBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
`;

const SearchContainer = styled.div`
  width: 27rem;
  margin-right: 1.2rem;
`;
const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  border-radius: 0.8rem;
  border: 1px solid ${Colors.grey600};
  padding: 0.9rem 0.8rem;
  margin-right: 1.2rem;
  cursor: pointer;
`;

const FilterIcon = styled.div`
  width: 2rem;
  height: 2rem;
  margin-right: 0.8rem;
`;
const ViewTypeContainer = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  border-radius: 0.8rem;
  border: 1px solid ${Colors.grey600};
  padding: 0.3rem;
`;

const ViewTypeItem = styled.div<{ active: string }>`
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.7rem;
  background: ${(props) => (props.active === "true" ? Colors.grey700 : "")};
  color: ${(props) =>
    props.active === "true" ? Colors.white100 : Colors.grey500};
  transition: all ease-in-out 0.15s;
`;

const ViewTypeIcon = styled.div`
  width: 2rem;
`;
